import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import type { Invoice, UpdateInvoiceBatchPayload } from 'contracts/Invoice';

const { Types, Creators } = createActions(
  {
    request: ['payload', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'RELEASE_INVOICES_TO_TRACKING_',
  }
);

export interface ReleaseInvoicesToTrackingState {
  data: Invoice[];
  loading: boolean;
  errorMessage: string | null;
}

export interface ReleaseInvoicesToTrackingRequestAction {
  payload: UpdateInvoiceBatchPayload;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Invoice[];
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: ReleaseInvoicesToTrackingState = {
  data: [],
  loading: false,
  errorMessage: null,
};

const request = (state: ReleaseInvoicesToTrackingState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: ReleaseInvoicesToTrackingState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: ReleaseInvoicesToTrackingState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: ReleaseInvoicesToTrackingState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const releaseInvoicesToTracking = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const ReleaseInvoicesToTrackingTypes = Types;
export const ReleaseInvoicesToTrackingActions = Creators;
